module.exports = __webpack_public_path__ + "img/blog-2-1.9b82bcc3.webp";